import React, { useState, useEffect } from 'react';
import { FiCalendar } from 'react-icons/fi';

const AgeVerification: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [day, setDay] = useState('');
  const [month, setMonth] = useState('');
  const [year, setYear] = useState('');

  useEffect(() => {
    const verified = localStorage.getItem('ageVerified');
    if (!verified) {
      setIsVisible(true);
    }
  }, []);

  const handleVerify = () => {
    const birthDate = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
    const today = new Date();
    const age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    const dayDiff = today.getDate() - birthDate.getDate();

    const actualAge = monthDiff < 0 || (monthDiff === 0 && dayDiff < 0) ? age - 1 : age;

    if (actualAge >= 18) {
      localStorage.setItem('ageVerified', 'true');
      setIsVisible(false);
    } else {
      alert('Vous devez avoir au moins 18 ans pour accéder à ce site.');
    }
  };

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 z-[100] bg-black/90 backdrop-blur-sm flex items-center justify-center p-4 animate-fade-in">
      <div className="bg-dark-card border border-dark-border rounded-2xl p-8 max-w-md w-full shadow-2xl animate-slide-up">
        <div className="text-center mb-6">
          <FiCalendar className="w-16 h-16 mx-auto text-accent-primary mb-4" />
          <h2 className="text-2xl font-bold text-white mb-2">
            Vérification de l'âge
          </h2>
          <p className="text-dark-muted">
            Vous devez avoir au moins 18 ans pour accéder à ce site.
          </p>
        </div>

        <div className="space-y-4 mb-6">
          <div>
            <label className="block text-sm font-medium text-dark-text mb-2">
              Date de naissance
            </label>
            <div className="grid grid-cols-3 gap-3">
              <input
                type="number"
                placeholder="Jour"
                min="1"
                max="31"
                value={day}
                onChange={(e) => setDay(e.target.value)}
                className="bg-dark-surface border border-dark-border rounded-lg px-4 py-2 text-white focus:outline-none focus:ring-2 focus:ring-accent-primary"
              />
              <input
                type="number"
                placeholder="Mois"
                min="1"
                max="12"
                value={month}
                onChange={(e) => setMonth(e.target.value)}
                className="bg-dark-surface border border-dark-border rounded-lg px-4 py-2 text-white focus:outline-none focus:ring-2 focus:ring-accent-primary"
              />
              <input
                type="number"
                placeholder="Année"
                min="1900"
                max={new Date().getFullYear()}
                value={year}
                onChange={(e) => setYear(e.target.value)}
                className="bg-dark-surface border border-dark-border rounded-lg px-4 py-2 text-white focus:outline-none focus:ring-2 focus:ring-accent-primary"
              />
            </div>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row gap-3">
          <button
            onClick={handleVerify}
            className="flex-1 bg-accent-primary hover:bg-accent-primary/90 text-white font-semibold py-3 px-6 rounded-lg transition-colors"
          >
            J'ai plus de 18 ans
          </button>
          <a
            href="https://www.joueurs-info-service.fr/"
            target="_blank"
            rel="noopener noreferrer"
            className="flex-1 bg-dark-surface hover:bg-dark-border text-white font-semibold py-3 px-6 rounded-lg transition-colors text-center"
          >
            Jeu responsable
          </a>
        </div>
      </div>
    </div>
  );
};

export default AgeVerification;

